<template>
    <div v-cloak>
        <portal to="modal">
            <modal :large="true"
                   v-if="showModal"
                   v-slot:default="props"
                   @hide="showModal = false"
            >
                <template v-if="! complete">
                    <h2 class="mb-3">{{ formConfig.title }}</h2>
                    <div class="text-gray-600"
                         v-html="formConfig.body"
                         v-if="formConfig.body"
                    ></div>

                    <p class="mt-6 text-xs text-red-600"
                       v-if="hasError('key')"
                    >
                        {{ getErrorFor('key') }}
                    </p>

                    <div class="grid sm:grid-cols-2 gap-6 mt-6">
                        <form-input v-model="form[field.name]"
                                    :type="field.type"
                                    :label="field.label"
                                    :name="field.name"
                                    :id="field.name"
                                    :error="getErrorFor(field.name)"
                                    :class="{ 'sm:col-span-2': hasOddNumberOfFormFields && index + 1 === formConfig.form_fields.length }"
                                    v-for="(field, index) in formConfig.form_fields"
                                    :key="field.name"
                        ></form-input>
                    </div>

                    <div class="flex items-center mt-6">
                        <form-toggle v-model="form.privacy_policy"></form-toggle>

                        <div class="ml-2">
                            I have read and accept the
                            <a href="/privacy_policy" target="_blank" class="text-primary-600 hover:underline">privacy policy</a>
                        </div>
                    </div>

                    <div class="ml-12 mt-1 text-xs text-red-600" v-if="hasError('privacy_policy')">
                        {{ getErrorFor('privacy_policy') }}
                    </div>

                    <div class="mt-5 sm:mt-12 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                        <span class="flex w-full rounded-md shadow-sm sm:col-start-2">
                            <form-button class="w-full"
                                         @click.native="submitLeadForm"
                            >
                                <span v-html="formConfig.submit_button_text"></span>
                            </form-button>
                        </span>
                        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1">
                            <form-button colour="white"
                                         class="w-full"
                                         @click.native="rejectLeadForm(props.hide)"
                            >
                                No Thanks
                            </form-button>
                        </span>
                    </div>

                    <div class="mt-8 text-sm text-gray-500"
                         v-html="formConfig.terms"
                    ></div>
                </template>

                <template v-else>
                    <h2 class="mb-3">{{ complete_title }}</h2>
                    <div class="text-gray-600 space-y-4"
                         v-html="complete_body"
                         v-if="complete_body"
                    ></div>

                    <div class="mt-5 sm:mt-12 sm:grid sm:gap-3 sm:grid-flow-row-dense">
                        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1">
                            <form-button colour="white"
                                         class="w-full"
                                         @click.native="props.hide()"
                            >
                                Close
                            </form-button>
                        </span>
                    </div>
                </template>
            </modal>
        </portal>
    </div>
</template>

<script>
    import FormInput from "../form/Input";
    import FormButton from "../form/Button";
    import FormToggle from "../form/public/Toggle";
    import Modal from "../Modal";

    import Form from "../../mixins/Form";

	export default {
	    data() {
	        return {
	            showModal: true,

                form: {
	                form_id: this.formConfig.id,
	                key: this.formConfig.secret,
                    privacy_policy: false,
                },

                complete: false,
                complete_title: '',
                complete_body: '',
            }
        },

	    props: {
	        formConfig: {
	            type: Object,
                required: true,
            }
        },

        components: { FormInput, FormButton, FormToggle, Modal },

        mixins: [Form],

        created() {
	        _.forEach(this.formConfig.form_fields, field => {
	            this.$set(this.form, field.name, '');
            });
        },

        computed: {
	        hasOddNumberOfFormFields() {
	            return this.formConfig.form_fields.length % 2 !== 0;
            }
        },

        methods: {
	        submitLeadForm() {
                this.post(route('lead.form.store').url())
                    .then(response => {
                        this.complete_title = response.data.title
                        this.complete_body = response.data.body
                        this.complete = true;
                    })
            },

            rejectLeadForm(hide) {
	            axios.post(route('lead.form.reject').url(), { form_id: this.form.form_id });

                hide();
            }
        }
    }
</script>
